import { Box } from '@material-ui/core';
import { useFormik } from 'formik';
import LocaleKeys from '../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import ButtonAction from '../../../../accountInfo/components/buttonAction';
import * as Yup from 'yup';
import VoucherCodeField from '../../../../common/forms/fields/components/voucherCodeField';
import { voucherCodeFormName } from '../../../../constants/checkout.constant';

const useStyles = makeStyles((theme) => ({
  'field__input--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  nameContainerNode: {
    flexWrap: 'wrap',
  },
  alert: {
    color: theme.palette.custom.darkRed,
    backgroundColor: theme.palette.custom.lightGrayishRed,
    borderColor: '#ebccd1',
    marginBottom: '10px',
    padding: '15px',
    border: '1px solid transparent',
    borderRadius: '4px',
    fontFamily: 'Formula1-Bold',
    fontSize: '14px',
  },
  alertSpan: {
    color: theme.palette.custom.darkRed,
  },
  nameField: {
    [theme.breakpoints.between('xs', 'md')]: {
      width: '100%',
    },
  },
}));

const VoucherCodeForm = ({
  handleCancel,
  handleSave,
  language,
  formData,
  formName,
  credentialErrorMessage,
  autoFocusRef,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const voucherCodeMessage = t(
    LocaleKeys.payment.orders.subscriptionItemApplyCouponIsRequired,
  );

  const VoucherCodeFieldSchema = Yup.object().shape({
    voucherCode: Yup.string().required(voucherCodeMessage),
  });

  const formik = useFormik({
    initialValues: { ...formData },
    enableReinitialize: true,
    validationSchema: VoucherCodeFieldSchema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: (values) => {
      handleSave({ name: formName, formik, values });
    },
  });

  return (
    <Box mb={4}>
      {credentialErrorMessage ? (
        <Box className={classes.alert}>
          <span className={classes.alertSpan}>{credentialErrorMessage}</span>
        </Box>
      ) : null}
      <form onSubmit={formik.handleSubmit}>
        <Box className={classes.nameContainerNode}>
          <Box className={`field field--voucherCode ${classes.nameField}`}>
            <VoucherCodeField
              name={voucherCodeFormName}
              label={t(
                LocaleKeys.payment.orders
                  .subscriptionItemApplyCouponHeaderLabel,
              )}
              form={formik}
              key={1}
              language={language}
              autoFocusRef={autoFocusRef}
            />
          </Box>
        </Box>
        <ButtonAction
          cancelHandler={handleCancel}
          formik={formik}
          saveLabel={t(
            LocaleKeys.payment.orders.subscriptionItemApplyCouponButtonLabel,
          )}
          cancelLabel={t(LocaleKeys.payment.orders.paymentFormCancel)}
          classes={classes}
          name={formName}
          justifyContent={'flex-start'}
        />
      </form>
    </Box>
  );
};

export default VoucherCodeForm;
